import React from 'react'
import "./Ratemymanagerworks.css"
import managersflag from "../../assets/images/ratemanagersflag.png"
import managersavatar from "../../assets/images/ratemanagersavatar.png"
import managerslikedislike from "../../assets/images/likedislikes.png"

const Ratemymanagerworks = () => {
  return (
    <div className='px-lg-2 px-md-2 px-2'>
      <div className='container'>
        <div className='row'>
            <div className='col-12'>
                <div className='text-center'>
                <h3 className='rate_manager_h3 pt-lg-4 pt-md-3 pt-3'>How Rate My Manager Works</h3>
                <p className='rate_manager_p pt-1'>Empower change, recognize excellence, and share your voice with a review</p>
                </div>
            </div>
        </div>
        <div className='row px-2'>
        <div className="col-lg-4 col-md-4 col-4 mb-3 px-lg-2 px-md-2 px-1">
          <div className="rate_managers_box pt-lg-0 pt-md-0 pt-1">
            <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                <img src={managersflag} className='img-fluid'></img>
                <h5 className='rate_managers_h5 pt-2 text-center'>Rate your manager</h5>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-4 mb-3 px-lg-2 px-md-2 px-1">
          <div className="rate_managers_box pt-lg-0 pt-md-0 pt-1">
            <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                <img src={managersavatar} className='img-fluid'></img>
                <h5 className='rate_managers_h5 pt-2 text-center'>All ratings are anonymous</h5>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-4 mb-3 px-lg-2 px-md-2 px-1">
          <div className="rate_managers_box pt-lg-0 pt-md-0 pt-1">
            <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                <img src={managerslikedislike} className='img-fluid'></img>
                <h5 className='rate_managers_h5 pt-2 text-center'>Like or dislike reviews</h5>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Ratemymanagerworks
